import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestTimePickerInput } from 'components/HonestTimePicker/HonestTimePickerInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createMealType, editMealType } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const MealTypeModal = ({ closeModal, value }: { closeModal: any, value?: IMealTypeModal }) => {
    const [state, setState] = useState(value || {
        name: '',
        serviceWindowStart: '',
        serviceWindowEnd: '',
        planningCutOffTime: ''
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        setState({ ...state, [name]: e.target.value })
    }

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resp = await dispatch(value?.id ? editMealType({ ...state, id: value.id }) : createMealType(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleTimeChange = (time: any, name: string) => {
        setState({ ...state, [name]: time })
    }

    function timeToMinutes(time) {
        const [hours, minutes] = time.split(':').map(Number)
        return hours * 60 + minutes;
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Meal Type</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Breakfast, snack, lunch...' labelText='Meal type name' value={state.name} onChange={e => handleChange(e, 'name')} nomarg />
                <HonestTimePickerInput
                    labelText='Service Window Start'
                    onChange={(time) => handleTimeChange(time, 'serviceWindowStart')}
                    defaultValue={state ? timeToMinutes(state.serviceWindowStart) : null}
                    nomarg
                />
                <HonestTimePickerInput
                    labelText='Service Window End'
                    onChange={(time) => handleTimeChange(time, 'serviceWindowEnd')}
                    defaultValue={state ? timeToMinutes(state.serviceWindowEnd) : null}
                    nomarg

                />
                <HonestTimePickerInput
                    labelText='Planning Cut Off Time'
                    onChange={(time) => handleTimeChange(time, 'planningCutOffTime')}
                    defaultValue={state ? timeToMinutes(state.planningCutOffTime) : null}
                    nomarg

                />
            </Flex>
            <Button mt='16' disabled={!state.name || !state.serviceWindowStart || !state.serviceWindowEnd || !state.planningCutOffTime} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IMealTypeModal {
    id?: number
    name: '',
    serviceWindowStart: '',
    serviceWindowEnd: '',
    planningCutOffTime: ''
}